import { StyleSheet } from "aphrodite"; 
import theme from "../../../common/theme/mellon";

export default StyleSheet.create({
    branchList: {
        display: "flex",
        flexDirection: "column",
        alignSelf: "flex-start",
        paddingLeft: "6%",
        paddingRight: "6%",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        width: "100%",
        overflowY: "auto",
        minHeight: 360,
        height: "calc(100vh - 470px)",
        '@media (max-width: 799px)': {
            height: "calc(100vh - 320px)",
            padding: "0px"
        }
    },
    row: {
        display: "flex",
        // DOM order: CTA first (focus), then branch info.
        // row-reverse keeps visual layout: info left, CTA right on desktop.
        flexDirection: "row-reverse",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        borderBottom: `1px solid ${theme.palette.primary.dark}`,
        margin: "20px 0px",
        paddingBottom: "20px",
        color: theme.palette.primary.dark,
        '@media (max-width: 799px)': {
            flexDirection: "column",
            alignItems: "stretch",
            justifyContent: "center",
            padding: "0px 28px",
            margin: "15px 0px",
            paddingBottom: "15px"
        }
    },
    branchInfoColumn: {
        flexDirection: "column",
        display: "flex",
        flex: 1,
        minWidth: 0,
    },
    branchDetails: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "center",
        marginTop: "5px",
        gap: "0px",
    },
    separator: {
        color: theme.palette.primary.dark,
    },
    button: {
        width: "100%",
        minWidth: "100%",
        height: 60,
        marginTop: "7px",
        borderRadius: 0,
    },
    centerEmptyContainer: {
        margin: "auto"
    }
});